import { Injectable } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, Validators } from "@angular/forms";
import { FieldBase } from "./field-base";

@Injectable()
export class FieldControlService {
  constructor(private fb: UntypedFormBuilder) { }

  toFormGroup(fields: FieldBase<any>[], customValidator?: Function, args?: String[], debug?: Boolean) {
    const convertToGroup = (fields: Array<any>) =>
      fields.reduce((acc, cur) => Object.assign(acc, cur), {});
    const handleEachItem = (item: any) => {
      let x = {};
      x[item.key] = new UntypedFormControl(item.value);
      this._applyValidators(x[item.key], item);
      return x;
    };
    const processedRows = fields.map(handleEachItem);
    if (customValidator) {
      const fcs = this.fb.group(convertToGroup(processedRows), { validator: eval(customValidator(...args)) });
      return fcs;
    }
    else {
      const fcs = this.fb.group(convertToGroup(processedRows));
      return fcs;
    }

  }

  private _applyValidators(formControl: UntypedFormControl, field: any) {
    let validators = [];
    if (field.required) {
      validators.push(Validators.required);
    }

    if (field["type"] === "email") {
      validators.push(Validators.email);
    }
    if (field["minlength"]) {
      validators.push(Validators.minLength(field["minlength"]));
    }
    if (field["maxlength"]) {
      validators.push(Validators.maxLength(field["maxlength"]));
    }
    if (field.type == "number" && field["min"]) {
      validators.push(Validators.min(field["min"]));
    }
    if (field.type == "number" && field["max"]) {
      validators.push(Validators.max(field["max"]));
    }
    if (field["pattern"]) {
      validators.push(Validators.pattern(field["pattern"]));
    }
    if (validators.length > 0) {
      formControl.setValidators(validators);
    }
  }
}
